import { module } from 'modujs'
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import Datepicker from '@vuepic/vue-datepicker'

export default class extends module {
    init() {
        this.app = createApp({
            delimiters: [ '${', '}' ],
            components: {
                Datepicker
            },
            data: () => ({
                adults: {
                    min: 1,
                    max: 10,
                    value: 1,
                    label: 'adult',
                },
                children: {
                    min: 0,
                    max: 10,
                    value: 0,
                    label: 'child',
                },
                date: [],
                codeType: '',
                code: '',
            }),
            methods: {
                addAdult(e) {
                    if (this.adults.value < this.adults.max) {
                        this.adults.value++
                        this.updateAdultsLabel()
                    }
                },
                substractAdult(e) {
                    if (this.adults.value > 0) {
                        this.adults.value--
                        this.updateAdultsLabel()
                    }
                },
                updateAdultsLabel() {
                    if (this.adults.value > 1) {
                        this.adults.label = 'adults'
                    } else {
                        this.adults.label = 'adult'
                    }
                },
                addChild(e) {
                    if (this.children.value < this.children.max) {
                        this.children.value++
                        this.updateChildrensLabel()
                    }
                },
                substractChild(e) {
                    if (this.children.value > this.children.min) {
                        this.children.value--
                        this.updateChildrensLabel()
                    }
                },
                updateChildrensLabel() {
                    if (this.children.value > 1) {
                        this.children.label = 'children'
                    } else {
                        this.children.label = 'child'
                    }
                },
                getFormattedDate(date) {
                    const day = date.getDate();
                    const month = date.getMonth() + 1;
                    const year = date.getFullYear();

                    return `${year}-${month}-${day}`
                },
                getUrl() {
                    if(!this.isValidForSubmission) {
                        return null
                    }

                    let url = this.$refs.form.action
                    if (!url) {
                        return null
                    }

                    const dateStart = this.getFormattedDate(this.date[0])
                    const dateEnd = this.getFormattedDate(this.date[1])

                    url += `&arrive=${dateStart}&depart=${dateEnd}`

                    if(this.adults.value > 0) {
                        url += `&adult=${this.adults.value}`
                    }

                    if(this.children.value > 0) {
                        url += `&child=${this.children.value}`
                    }

                    if(this.codeType !== '' && this.code !== '') {
                        url += `&${this.codeType}=${this.code}`
                    }

                    // Google Analytics injects the cross-domain measurement
                    // linker parameter (`_gl`), as a hidden input, when the
                    // form's `submit` event is dispatched.
                    const gl = this.$refs.form.querySelector('[name="_gl"]')?.value
                    if (gl) {
                        url += `&_gl=${gl}`
                    }

                    return url
                },
                submit() {
                    requestAnimationFrame(() => {
                        const url = this.getUrl()
                        url && window.open(url, '_blank')
                    })
                },
            },
            computed: {
                isValidForSubmission() {
                    return this.adults.value > 0 && this.date.length > 0
                }
            }
        }).mount(this.el)
    }
}
